<template>
  <div class="w-100">
    <spinner v-if="loading" class="m-x-auto m-y-6" size="100px" color="gray80"/>
    <div v-else >
      <div v-if="!hasSubmit" class="text-center">
        <img

            class="ONLY-IMAGE"
            src="./../assets/emptystate_hammer.svg"
        />
      </div>
      <div v-else >
        <div class="d-flex fd-column">

          <div v-if="noData" class="text-center">
            <div class="p-b-2">
              We're sorry! You don't have any performance data from these dates.
              Try another date range.
            </div>
            <img
                class="IMAGE"
                src="./../assets/emptystate_wheelbarrow.svg"
            />
          </div>
          <div v-else class="p-b-3">
            <div v-if="isMobile">
              <div>
                <div class="SELECT p-x-4:t">
                  Sort by
                  <select-box
                      class="m-b-2"
                      v-model="sortBy"
                      :options="$options.SORTKEYS"
                      @change="updateSelectedSort"
                      option-label="label"
                      option-value="key"/>
                  <div
                      v-for="{ sort, text } in currentRadios"
                      :key="sort"
                      class="radio RADIO">
                    <input
                        type="radio"
                        :id="sort"
                        name="sort"
                        :value="sort"
                        v-model="selectedSort"
                    />
                    <label :for="sort" :key="sort" class="m-r-5">
                      {{ text }}
                    </label>
                  </div>
                  <div v-if="showInfo" class="d-flex p-y-1">
                    <div>
                      <vk-icon
                          name="information-filled"
                          size="18"
                          class="INFO"
                          unbounded/>
                    </div>
                    <div>{{ sortBy==='your_action'? yourActionTip: currentStatusTip}}</div>
                  </div>

                </div>
                <history-item
                    v-for="(item, index) in sortedHistoryItems"
                    :property='sortBy'
                    :key="index"
                    :job="item"
                    :index="index"
                    :isMobile="isMobile"
                />
              </div>
            </div>
            <div
                v-else
                class="d-flex p-x-4 ">
              <div class="d-flex fd-column ac-center flex-1-0">
                <div class="text-bold LABEL m-l-2 m-r-2">
                  Job ID
                </div>
                <div class="bd-b-gray40 m-t-2"/>
                <div class="c-depot">
                  <history-item
                      v-for="(item, index) in sortedHistoryItems"
                      class="link"
                      property='id'
                      :key="index"
                      :job="item"
                      :index="index"
                  />
                </div>
              </div>
              <div class="d-flex fd-column flex-1-0">
                <div  id="date" class="text-bold LABEL m-r-1">
                  Recieved Date / Time
                  <a
                      id="date"
                      @click="toggleDirection('date')">
                    <vk-icon
                        class="c-depot"
                        id="date"
                        :name="directionState.date === 'date' ? 'chevronup' : 'chevrondown'"
                        unbounded/>
                  </a>
                </div>
                <div class="bd-b-gray40  m-t-2"/>
                <div>
                  <history-item
                      v-for="(item, index) in sortedHistoryItems"
                      property='date'
                      :key="index"
                      :job="item"
                      :index="index"
                  />
                </div>
              </div>
              <div class=" d-flex fd-column flex-2-0">
                <div class="text-bold LABEL m-r-1">
                  Customer Name
                </div>
                <div class="bd-b-gray40  m-t-2"/>
                <div>
                  <history-item
                      v-for="(item, index) in sortedHistoryItems"
                      property='name'
                      :key="index"
                      :job="item"
                      :index="index"
                  />
                </div>
              </div>
              <div class=" d-flex fd-column flex-1-0">
                <div class="text-bold LABEL m-r-1">
                  Service Type
                  <a
                      id="service_name"
                      @click="toggleDirection('service_name')">
                    <vk-icon
                        id="service_name"
                        class="c-depot"
                        :name="directionState.service_name === 'service_name'
                          ? 'chevronup'
                        : 'chevrondown'"
                        unbounded/>
                  </a>
                </div>
                <div class="bd-b-gray40  m-t-2"/>
                <div>
                  <history-item
                      v-for="(item, index) in sortedHistoryItems"
                      property='service_name'
                      :key="index"
                      :job="item"
                      :index="index"
                  />
                </div>
              </div>
              <div class=" d-flex fd-column flex-1-0">
                <div class="text-bold LABEL m-r-1">
                  Lead Cost
                </div>
                <div class="bd-b-gray40  m-t-2"/>
                <div>
                  <history-item
                      v-for="(item, index) in sortedHistoryItems"
                      property='cost'
                      :key="index"
                      :job="item"
                      :index="index"
                  />
                </div>
              </div>
              <div class=" d-flex fd-column flex-1-0">
                <div class="text-bold LABEL m-r-1 d-flex fd-row">
                  Job Status
                  <div v-tooltip="{content: yourActionTip, offset:'8'}">
                    <vk-icon
                        name="information-filled"
                        size="18"
                        class="INFO"
                        unbounded/>
                  </div>
                  <a
                      id="action"
                      @click="toggleDirection('your_action')">
                    <vk-icon
                        id="your_action"
                        class="c-depot"
                        :name="directionState.action === 'your_action'
                          ? 'chevronup'
                        : 'chevrondown'"
                        unbounded/>
                  </a>

                </div>
                <div class="bd-b-gray40  m-t-2"/>
                <div>
                  <history-item
                      v-for="(item, index) in sortedHistoryItems"
                      property='your_action'
                      :key="index"
                      :job="item"
                      :index="index"
                  />
                </div>
              </div>
              <div class=" d-flex fd-column flex-1-0">
                <div class="text-bold LABEL d-flex fd-row ">
                  Current Status
                  <div v-tooltip="{content: currentStatusTip, offset:'8'}">
                    <vk-icon
                        name="information-filled"
                        size="18"
                        class="INFO"
                        unbounded/>
                  </div>
                  <a
                      id="status"
                      @click="toggleDirection('current_status')">
                    <vk-icon
                        id="current_status"
                        class="c-depot"
                        :name="directionState.status === 'current_status'
                          ? 'chevronup'
                        : 'chevrondown'"
                        unbounded/>
                  </a>
                </div>
                <div class="bd-b-gray40  m-t-2"/>
                <div>
                  <history-item
                      v-for="(item, index) in sortedHistoryItems"
                      property='current_status'
                      :key="index"
                      :job="item"
                      :index="index"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectBox from '@/components/SelectBox';
import { keys } from '@/constants/historySortKeys';
import HistoryItem from './HistoryItem';

export default {
  SORTKEYS: keys,
  name: 'history-item-list',
  components: { HistoryItem, SelectBox },
  props: {
    historyJobs: {
      type: Array,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
    hasSubmit: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      yourActionTip: 'Job Status reflects your response to the lead when Pro Referral passed it to you.',
      currentStatusTip: 'The Current Status of the lead reflects the final outcome of this job, either by you or another pro who accepted, completed or cancelled this lead later.',
      sortBy: 'date',
      selectedSort: 'new',
      proId: this.serviceProviderId,
      directionState: {
        date: null,
        service_name: null,
        your_action: null,
        current_status: null,
      },
    };
  },
  computed: {
    showInfo () {
      if (this.sortBy === 'current_status') {
        return true;
      }
      if (this.sortBy === 'your_action') {
        return true;
      }
      return false;
    },
    noData () {
      return this.historyJobs.length < 1;
    },
    selected () {
      return this.sortBy === 'date' ? 'new' : 'a-z';
    },
    currentRadios () {
      return this.sortBy === 'date' ? [
        { sort: 'new', text: 'Newest' },
        { sort: 'old', text: 'Oldest' },
      ]
        : [
          { sort: 'a-z', text: 'A-Z' },
          { sort: 'z-a', text: 'Z-A' },
        ];
    },
    sortedHistoryItems () {
      const items = this.historyJobs;
      const valueOfPicker = this.sortBy;
      const valueOfRadio = this.selectedSort;

      if (!items) return;

      if (valueOfPicker === 'date') {
        return items.sort((a, b) => {
          const dateA = new Date(a.time_created);
          const dateB = new Date(b.time_created);
          return (valueOfRadio === 'new' ? dateB - dateA : dateA - dateB);
        });
      } if (valueOfPicker === 'service_name') {
        return items.sort((a, b) => {
          const serviceTypeA = a.work_order.service_name;
          const serviceTypeB = b.work_order.service_name;
          return (valueOfRadio === 'a-z'
            ? serviceTypeA.localeCompare(serviceTypeB) : serviceTypeB.localeCompare(serviceTypeA));
        });
      } if (valueOfPicker === 'your_action') {
        return items.sort((a, b) => {
          const statusA = a.your_action;
          const statusB = b.your_action;
          return (valueOfRadio === 'a-z'
            ? statusA.localeCompare(statusB) : statusB.localeCompare(statusA));
        });
      } if (valueOfPicker === 'current_status') {
        return items.sort((a, b) => {
          const statusA = a.current_status;
          const statusB = b.current_status;
          return (valueOfRadio === 'a-z'
            ? statusA.localeCompare(statusB) : statusB.localeCompare(statusA));
        });
      }
    },
  },
  methods: {
    updateSelectedSort (newSort) {
      if (newSort === 'date') {
        this.selectedSort = this.selectedSort === 'new' ? 'old' : 'new';
        return;
      }
      this.selectedSort = this.selectedSort === 'a-z' ? 'z-a' : 'a-z';
    },
    toggleDirection (id) {
      this.directionState[id] = this.directionState[id] === id ? true : id;
      this.sortBy = id;
      this.updateSelectedSort(id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

.SELECT {
  padding: $unit 1.5 * $unit $unit 1.5*$unit
}
.LABEL {
  max-height: 21px;
  font-size: 1.75 * $unit;
}
.ONLY-IMAGE {
  align-self: center;
  padding: 7 * $unit 0 3 *$unit;
}
.INFO {
  padding: 0 .5  * $unit;
  color: #3E7697;
}
.IMAGE {
  align-self: center;
  padding-bottom: 3 *$unit;
  @include mobile-only {
  }
}
</style>
